

import React, {Suspense, useEffect, useState} from 'react';
import {useTranslation} from "react-i18next";
import PortfolioApi from "../components/api/portfolio_api";
import {Link} from "react-router-dom";
import Helmet from "react-helmet";
import ServicesApi from "../components/api/services_api";
import ServicesPage from "./services";
import SectionServices from "../components/sections/services";
import {MotionAnimate} from "react-motion-animate";
import CardCertification from "../components/card/card_certification";
import axios from "axios";

function CertificatesPage(props) {

    const { t, i18n } = useTranslation()

    const [certificate, setSertificate] = useState([]);

    const [load, setLoad] = useState(true);

    useEffect(()=> {

        axios.get(
            'https://api.lukyanchuk.com/api/v1/public/resume/certificate?sort=DESC'
        ).then(function (response) {
            const getSertificate = response.data.data;
            setSertificate(getSertificate);
            console.log(getSertificate);
            setLoad(false);
        }).catch(err => {
            // In case it errors.
            console.log(err);
        });

    }, []);


    const dataYears = [2024, 2023, 2022, 2021, 2020, 2019]

    const [filterYear, setFilterYear] = useState(0);

    const handleFilter = (value) => {
        setFilterYear(value)
    }

    return ( load ? 'Loading...' : <div className={'min-vh-100'}>

        <Helmet>
            <title>{t('nav.certificates')} - Yaroslav Lukyanchuk</title>
            <meta name="description" content="Yaroslav Lukyanchuk" />
        </Helmet>

        <div className="container text-dark text-start pt-5 pb-4">

            <h1 className={'opacity-50'} style={{fontSize: '10vw'}}>{t('nav.certificates')}</h1>

            <div className="d-flex flex-wrap">
                <div className="col-md-">
                    <div className={'pt-2 p-1'}>
                        <button className="btn bg-secondary-subtle p-2 rounded" onClick={() => handleFilter(0)}>
                            <small className={'text-uppercase'}> {t('subTitle.all')} </small>
                        </button>
                    </div>
                </div>
                {
                    dataYears.map((year, i) => <div className="col-md-">
                        <div className={'pt-2 p-1'}>
                            <button className="btn bg-secondary-subtle p-2 rounded" onClick={() => handleFilter(year)}>
                                <small> {year}</small>
                            </button>
                        </div>
                    </div>)
                }


            </div>

            {
                // certificate.slice(0, 3)
                certificate.length > 0 &&
                certificate.filter((a) => filterYear != 0 ? a.data == filterYear : true).map((item, i) => <CardCertification item={item} />)
            }

        </div>
    </div>);
}

export default CertificatesPage;
